import React from "react";
import { Table, Badge, Button, Card } from "react-bootstrap";

const StatusBadge = ({ status }) => {
  const s = (status || "").toLowerCase();
  let bgProps = { bg: "light", text: "dark" };
  
  if (s.includes("success") || s.includes("accepted")) {
    bgProps = { bg: "success-subtle", text: "success" };
  } else if (s.includes("fail")) {
    bgProps = { bg: "danger-subtle", text: "danger" };
  } else if (s.includes("pending")) {
    bgProps = { bg: "warning-subtle", text: "warning" };
  }

  return (
    <Badge 
      bg={bgProps.bg} 
      text={bgProps.text} 
      className="px-2 py-1 border border-light" 
      style={{ fontSize: "12px", border: "1px solid", borderColor: `var(--bs-${bgProps.text})` }}
    >
      {(status || "UNKNOWN").toUpperCase()}
    </Badge>
  );
};

export const TransactionGrid = ({ transactions, role, onSelectReceipt }) => {
  const isMainAdmin = role === "Main Admin";
  const isAdminOrWL = role === "Admin" || role === "White label" || isMainAdmin;

  return (
    <Card className="shadow-sm border-0">
      <Card.Body className="p-0">
        <div className="table-responsive">
          <Table hover className="align-middle mb-0" style={{ fontSize: "14.5px" }}>
            <thead className="table-light text-uppercase text-muted" style={{ fontSize: "12.5px" }}>
              <tr>
                <th className="py-3 px-4">Txn Details</th>
                <th className="py-3 px-4">Service</th>
                {isMainAdmin && <th className="py-3 px-4">Admin</th>}
                {isAdminOrWL && <th className="py-3 px-4">BC Name</th>}
                <th className="py-3 px-4 text-end">Amount</th>
                <th className="py-3 px-4 text-end">
                  {isMainAdmin ? "MAdmin Profit" : "Commission"}
                </th>
                <th className="py-3 px-4 text-end">
                  {isMainAdmin ? "MAdmin Closing" : "Closing Bal"}
                </th>
                <th className="py-3 px-4 text-center">Status</th>
                <th className="py-3 px-4 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {transactions.length === 0 ? (
                <tr>
                  <td colSpan={10} className="py-5 text-center text-muted">
                    No records found for the selected period.
                  </td>
                </tr>
              ) : (
                transactions.map((tx) => (
                  <tr key={tx.id}>
                    <td className="py-3 px-4">
                      <div className="fw-bold text-dark">
                        {tx.ref_no || tx.ack_no || `#${tx.id}`}
                      </div>
                      <div className="text-muted small">{tx.created_at || tx.txn_date}</div>
                      {tx.bank_rrn && (
                        <div className="text-primary small" style={{ fontFamily: "monospace" }}>RRN: {tx.bank_rrn}</div>
                      )}
                    </td>
                    <td className="py-3 px-4 text-capitalize">
                      <span className="fw-medium text-dark">
                        {tx.service || tx.product}
                      </span>
                      <div className="text-muted small">{tx.number || "—"}</div>
                    </td>
                    {isMainAdmin && (
                      <td className="py-3 px-4 fw-medium text-dark">
                        {tx.admin_name || tx.Admin || "—"}
                      </td>
                    )}
                    {isAdminOrWL && (
                      <td className="py-3 px-4">
                        <div className="fw-medium text-dark">{tx.bc_name || tx["BC Name"] || "—"}</div>
                        <div className="text-muted small">{tx.bc_phone || ""}</div>
                      </td>
                    )}
                    <td className="py-3 px-4 text-end fw-bold text-dark">
                      ₹{(tx.amount || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                    </td>
                    <td className="py-3 px-4 text-end fw-medium text-success">
                      +₹{isMainAdmin
                        ? (tx["Commission MAdmin"] || tx.my_commission || 0)
                        : (tx.my_commission || tx.bc_commission || 0)}
                    </td>
                    <td className="py-3 px-4 text-end text-dark" style={{ fontFamily: "monospace" }}>
                      ₹{isMainAdmin
                        ? (tx["Closing balance MAdmin"] || tx.my_closing || 0)
                        : (tx.my_closing || tx["Closing Balance BC"] || 0)}
                    </td>
                    <td className="py-3 px-4 text-center">
                      <StatusBadge status={tx.status} />
                    </td>
                    <td className="py-3 px-4 text-center">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="fw-semibold px-3 py-1 bg-primary-subtle border-0 text-primary hover-primary"
                        style={{ fontSize: "12px", borderRadius: "4px" }}
                        onClick={() => onSelectReceipt(tx)}
                      >
                        Receipt
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};
